<template>
   <Lottie
      :options="defaultOptions"
      style="width: 100%; padding-inline: 80px;"
      @animCreated="handleAnimation"
   />
</template>

<script>
import Lottie from 'vue-lottie'
import * as animationData from '@/assets/amination.json'

export default {
   components: { Lottie },
   data() {
      return {
         defaultOptions: { animationData: animationData.default },
      }
   },
   methods: {
      handleAnimation(animation) {
         this.anim = animation
      },
   },
}
</script>

<style>

</style>
